<div
  class="notification"
  [ngClass]="{ 'show-border': showBorder }"
  fxLayout="column">
  @if (messageType !== NotificationType.MassCommunication) {
    <div>
      <div
        fxLayout="row"
        fxLayoutAlign="end end">
        <div
          class="notification-display-close-button ml-4"
          (click)="markReadClick()">
          <i class="icon icon-small_close-X"></i>
        </div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="mt-4">
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          @if (!showDefaultIcon) {
            <div
              class="notification-display-from-icon">
              <img
                [src]="fromIcon"
                (error)="iconLoad($event)" />
            </div>
          }
          <div
            class="notification-display-from-name ml-2"
            [ngClass]="{ 'is-comment': messageType === NotificationType.Comment }">
            {{ fromName }}
          </div>
          @if (messageType === NotificationType.Comment) {
            <div
              class="notification-display-from-name-mention">
              {{ 'NOTIFICATIONS.MENTIONED-YOU-IN-COMMENT' | translate }}
            </div>
          }
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          @if (distance) {
            <div
              class="notification-display-distance-pill"
              fxLayout="row"
              fxLayoutAlign="space-between center">
              <div class="left-side">&nbsp;</div>
              <div
                class="distance-pill-value"
                fxLayout="row"
                fxLayoutAlign="start center">
                {{ distance }}
              </div>
              <div class="right-side">&nbsp;</div>
            </div>
          }
          @if (!isTransient) {
            <div
              (click)="goToIncident()">
              <i class="icon icon-popout navigation"></i>
            </div>
          }
        </div>
      </div>
      <div
        class="notification-display-message mt-3"
        [ngClass]="{ 'is-comment': messageType === NotificationType.Comment }"
      [innerHTML]="message | safeHtml"></div>
      @if (location && canZoomToDocument) {
        <div
          fxLayout="row"
          class="mt-3">
          <div
            class="notification-display-location-icon pr-1"
            (click)="zoomToDocument()">
            <i class="icon icon-zoom-to_location"></i>
          </div>
          <div class="notification-display-location">{{ location }}</div>
        </div>
      }
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="mt-2">
        <div fxLayout="row">
          <div class="notification-display-date-sent-label pr-1">{{ 'MAP.POSTED' | translate }}</div>
          <div class="notification-display-date-sent">{{ dateSentFormatted }}</div>
        </div>
        <div class="notification-display-elapsed-time">
          {{ dateSentElapsedTime }}
        </div>
      </div>
    </div>
  }
  @if (messageType === NotificationType.MassCommunication) {
    <div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          <div>
            <i class="icon icon-alert_solid escalated-icon"></i>
          </div>
          <div class="notification-display-from-name ml-2">
            {{ 'NOTIFICATIONS.ESCALATED-RESPONSE' | translate }}
          </div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          @if (!!datasetUId && !!documentUId) {
            <div
              fxLayout="row"
              class="mt-3">
              <div
                class="notification-display-location-icon pr-1"
                (click)="zoomToDocument()">
                <i class="icon icon-zoom-to_location"></i>
              </div>
            </div>
          }
          <div
            class="notification-display-close-button ml-4"
            (click)="markReadClick()">
            <i class="icon icon-small_close-X"></i>
          </div>
        </div>
      </div>
      @if (escalatedMessage) {
        <div
          class="escalated-message mt-3"
        [innerHTML]="escalatedMessage | safeHtml"></div>
      }
      @if (recipientName) {
        <div
          class="escalated-address mt-2"
          >
          {{ recipientName }}
        </div>
      }
      @if (notificationUId) {
        <div
          class="mt-2"
          fxLayout="row"
          fxLayoutGap="12px">
          <img
            class="bullhorn-image"
            src="assets/images/purple_bullhorn.svg" />
          <div class="communication-link">
            <a (click)="showSentMessage()">{{ message }}</a>
          </div>
        </div>
      }
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="mt-2">
        <div fxLayout="row">
          <div class="notification-display-date-sent-label pr-1">{{ 'MAP.POSTED' | translate }}</div>
          <div class="notification-display-date-sent">{{ dateSentFormatted }}</div>
        </div>
        <div class="notification-display-elapsed-time">
          {{ dateSentElapsedTime }}
        </div>
      </div>
    </div>
  }
</div>

<topo-communication-preview></topo-communication-preview>
<topo-comms-notification-edit></topo-comms-notification-edit>
